import { useState, useCallback } from "react";

const useTruncatedTextTooltip = () => {
    const [isTooltipEnabled, setIsTooltipEnabled] = useState(false);

    const refCallback = useCallback((node: HTMLDivElement | null) => {
        if (node) {
            setIsTooltipEnabled(node.scrollWidth > node.clientWidth);
        }
    }, []);

    return { isTooltipEnabled, refCallback };
};

export default useTruncatedTextTooltip;
